import { toUUID } from '../../util/transform';
import type { IOrganizationIntegrationLoanQ } from './OrganizationIntegrationLoanQ.interface';

export default class OrganizationIntegrationLoanQ implements IOrganizationIntegrationLoanQ {
  idWorkflow: string;
  enabled: boolean;

  isEnabled() {
    return this.enabled;
  }

  static build = (data: IOrganizationIntegrationLoanQ) =>
    new OrganizationIntegrationLoanQ(data);
  static blank = () => new OrganizationIntegrationLoanQ();

  /**
   * Constructor
   * @param {IOrganizationIntegrationLoanQ} data
   */
  constructor(data?: IOrganizationIntegrationLoanQ) {
    this.idWorkflow = toUUID(data?.idWorkflow);
    this.enabled = data?.enabled === true;
  }
}
